/* eslint-disable jsx-a11y/alt-text */
import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchBannerDownload,
  useBannerList,
} from "../../../api/banner/use-banner";
import { FallbackImage } from "../../../assets/img";
import Table from "../../../components/ui/Table/Table";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexVal =
          page === 1 ? total - index : total - index - (page - 1) * pageSize;

        return <div>{indexVal}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.status, {
      header: "등록 상태",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (
              val === "ON" ? (
                <span className="text-[#e80000]">사용중</span>
              ) : (
                "사용안함"
              )
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.code, {
      header: "배너코드",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.location, {
      header: "배너 위치",
      cell: (info) => {
        const val = info.getValue();
        // const top = val?.
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.title, {
      header: "배너 제목",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "미리보기",
      cell: (info) => {
        const status = info.getValue().status;
        const bannerImage = info.getValue().imagePC;
        const bannerImageApp = info.getValue().imageMobile;
        return (
          <div className="flex items-center justify-center gap-4 w-max m-auto">
            {status === "ON" ? (
              <img
                src={bannerImage}
                className="flex-none w-[200px] h-[50px] object-cover"
              />
            ) : (
              <div className="flex-none bg-[#dddddd] w-[200px] h-[50px] flex justify-center items-center">
                이미지 구역
              </div>
            )}
            {status === "ON" ? (
              <img
                src={bannerImageApp}
                className="flex-none  w-[120px] h-[50px] object-cover"
              />
            ) : (
              <div className="flex-none bg-[#dddddd] w-[120px] h-[50px] flex justify-center items-center">
                이미지 구역
              </div>
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.onAt, {
      header: "사용 시작일",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? dayjs(val).format("YYYY-MM-DD") : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "사용 종료일",
      cell: (info) => {
        const val = info.getValue()?.offAt;
        const status = info.getValue()?.status;
        return (
          <div className={`${status === "ON" ? "text-[#e80000]" : ""}`}>
            {val ? dayjs(val).format("YYYY-MM-DD") : "-"}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "등록일시",
      cell: (info) => {
        const val = info.getValue();
        const datetime = dayjs(val)?.format("YYYY-MM-DD HH:mm");
        return <div>{val ? datetime : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

const sorts = [
  {
    id: "",
    name: "최신순",
  },
  {
    id: "ON_AT_DESC",
    name: "사용 시작일 순",
  },
  {
    id: "OFF_AT_DESC",
    name: "사용 종료일 순",
  },
  {
    id: "CREATED_AT_DESC",
    name: "등록일시 순",
  },
];

function CustomLeftHeader({ onTotal, offTotal }) {
  return (
    <span>
      사용중 <span className="font-bold">{onTotal}</span>건 | 사용안함{" "}
      <span className="font-bold">{offTotal}</span>건
    </span>
  );
}

export function BannerManagementTable(props) {
  const { filter, onSort } = props;
  const { isEmpty, getDataTableProps } = useBannerList(filter);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;
  const onTotal = getDataTableProps().on;
  const offTotal = getDataTableProps().off;
  const onSave = async () => {
    await fetchBannerDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `banner-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <>
      {isEmpty ? (
        <>
          <div className="flex justify-center mt-[60px] text-[#999999] text-center">
            <span>
              등록된 배너가 없습니다. <br />
              배너등록을 완료해야만 배너관리의 정보가 등록됩니다.
            </span>
          </div>
        </>
      ) : (
        <>
          <Table
            customLeftHeader={
              <CustomLeftHeader onTotal={onTotal} offTotal={offTotal} />
            }
            hasPageSizeFilter={false}
            onSave={onSave}
            onSort={onSort}
            sorts={sorts}
            columns={columns(currentPage, pageSize, totalData)}
            width="w-48"
            dropdownWidth="w-32"
            {...getDataTableProps()}
          />
        </>
      )}
    </>
  );
}
